import { useSelector } from 'react-redux'
import { selectToken } from '../authentication/authenticationSlice'
import api from '../api'
import useDataLoader from '../dataLoader'

const useGetManualQueryDocument = (organizationId: number | null) => {
  const token = useSelector(selectToken)
  const fetchDocument = async (documentId: number) => {
    if (organizationId) {
      return await api.getManualQueryDocument({ token, organizationId, documentId })
    }
  }

  return useDataLoader(fetchDocument, [], null)
}

export default useGetManualQueryDocument
